import { GameEnvRegion, IGameEnvModel } from './env';

export enum CommonStatusStep {
  Pending, // 等待
  Resolve, // 通过
  Reject, // 拒绝
}
// 服务状态
export enum ServiceStatus {
  Pending = CommonStatusStep.Pending,
  Resolve = CommonStatusStep.Resolve,
  Reject = CommonStatusStep.Reject,
}

export enum ServiceBusiness {
  G6 = 'g6',
  Currency = 'currency',
  GCloud = 'gcloud',
  Bianque = 'bianque',
  DMP = 'dmp',
}

export enum ServiceSupportType {
  Iframe = 'iframe',
  Jump = 'jump',
}

// 服务列表item
export interface IAPIServiceConfigItem {
  readonly Business: ServiceBusiness;
  readonly CreateTime: Date;
  readonly FounderID: Number;
  readonly IconURL: string;
  readonly LastUpdaterID: string;
  readonly ModifyTime: Date;
  readonly Name: string;
  readonly ParentName: string;
  readonly Pic: string;
  readonly Sort: number; // 二级菜单排序
  readonly Status: CommonStatusStep;
  readonly SupportType: ServiceSupportType;
  readonly id: number;
  readonly DataSyncID?: string;

  readonly ParentSort: number; // 分类排序
  readonly ServicePath: string; // 第三方服务路径
  readonly JsonConfig: string; // json str
  readonly ReleaseSort: number; // 服务发布排序
  readonly UniqueName: string;
  readonly SubServiceNames?: string;
}

interface IServiceItem {
  readonly Name: string;
  readonly ParentName: string;
  readonly ServicePath: string;
  readonly SubServiceNames: string | null;
  readonly UniqueName: string | null;
}

// 服务审批列表
export interface IAPIServicesApproveItem {
  // readonly Business?: string; //
  readonly id: number;
  readonly StudioName: string; // 服务名称
  readonly StudioID: string;
  readonly Status: CommonStatusStep;
  readonly ServiceName: string;
  readonly ServiceID: number;
  readonly CreateTime: Date;
  readonly ModifyTime: Date;
  readonly GameName: string;
  readonly GameID: string;
  readonly ApproverUid: Number;
  readonly Approver: string;
  readonly ApplicantUid: Number;
  readonly Applicant: string;
  readonly ApprovalPayload?: string;

  // 新加
  readonly EnvID: Number;
  readonly Deployed: Number;
  readonly EnvItem: IGameEnvModel; // 添加
  readonly SubServiceName: any;
  readonly FeeOrderApproved: CommonStatusStep | null;
  readonly ServiceItem?: IServiceItem;
}
export interface IAPIApproveGameListItem {
  readonly GameID: string;
  readonly ProjectCode: string;
}
export interface IAPIApproveItem {
  readonly total: Number;
  readonly list: Array<IAPIServicesApproveItem>;
  readonly gameList: IAPIApproveGameListItem[];
}

export interface IApiSubServiceItem {
  serviceName?: string;
  service?: IAPIServicesOpenItem;
  subserviceName: string;
  tableID?: number;
  status: CommonStatusStep;
}

// 服务上下线列表
export interface IAPIServicesOpenItem {
  readonly id: number;
  readonly Status: CommonStatusStep;
  readonly ServiceID: number;
  readonly CreateTime: Date;
  readonly ModifierUserID?: string;
  readonly ModifyTime: Date;
  readonly GameID: string;
  readonly EnvID: Number;
  readonly Region?: GameEnvRegion;
  readonly ServiceName?: string;
  readonly SubServiceName: readonly IApiSubServiceItem[] | null;
}

export interface IAPIGameServicesOpenItem {
  readonly id: number;
  readonly Status: CommonStatusStep;
  readonly ServiceID: Number;
  readonly CreateTime: Date;
  readonly ModifyTime: Date;
  readonly GameID: string;
  readonly EnvID: Number;
}

// 创建服务
export interface IServiceConfigItem {
  readonly Name?: string;
  readonly Business?: ServiceBusiness;
  readonly SupportType?: ServiceSupportType;
  readonly ParentName?: string;
  readonly IconURL?: string;
  readonly Sort?: Number;
  readonly Pic?: string;
  readonly Status?: CommonStatusStep;
  readonly ParentSort?: number;
  readonly ServicePath?: string;
  readonly JsonConfig?: string; // 配置页面信息，大JSON字符串，作用于服务申请页面的相关说明文字和链接地址
  readonly ReleaseSort?: number; // 服务发布排序
  readonly SubServiceNames?: string;
  readonly UniqueName: string;
  readonly DataSyncID?: string;
  readonly DataSource?: 'support';
}

// 编辑服务
export interface IServiceConfigUpdateParam extends IServiceConfigItem {
  readonly id: Number;
}

// 权限同步-失败列表记录
export interface IAuthFailItem {
  readonly Business: string;
  readonly CreateTime: string;
  readonly FounderID: Number;
  readonly SyncValue: string;
  readonly ModifyTime: string;
  readonly FounderName: string;
  readonly Status: Number;
  readonly id: number;
}

// 权限同步-失败名单重试前确认
export interface IAuthSyncSureItem {
  readonly nextSyncUser?: IAuthSyncReqItem[];
  readonly abnormalUsers?: IAuthSyncReqItem[];
}

// 权限同步-重试提交
export interface IAuthSyncReqItem {
  readonly plat_id: number; // 平台ID
  readonly user_name: string; // 用户名<取唯一值UserID>
  readonly role_id: number; // 游戏权限
  readonly service_code: string; // 业务编码，就是游戏id
  readonly duration?: number; // 权限有效期（月）
  readonly expire_time?: number; // 权限过期时间戳，10位, unixtime
}

// 用户-获取列表
export interface IUserListItem {
  readonly UserName: string;
  readonly UserID: string;
  readonly id: number;
  readonly CreateTime: string;
}

// 用户-获取在线状态
export interface IUserOnlineItem {
  readonly UserID: string;
  readonly Online: boolean;
  readonly LastAccess: string;
}

// 游戏列表
export interface IGameListItem {
  readonly GameID: string;
  readonly Name: string;
  readonly StudioID: string;
  readonly CreateTime: string;
  readonly GameKey: string;
  readonly ModifyTime: string;
  readonly ProjectCode?: string;
  readonly CreatorUserID?: string;
  readonly Creator?: number;
  readonly ExtensionField?: any;
}

// 开通服务审批状态
export interface IServiceStatus {
  readonly status?: CommonStatusStep;
  readonly serviceID: number;
  readonly stage: string;
  readonly subserviceName: string | null;
}

// export interface IServiceApplyConfig {
//   readonly icon: string;
//   readonly description: string;
//   readonly docLink: ReadonlyArray<{
//     readonly title: string;
//     readonly url: string;
//     readonly description: string;
//   }>;
// }
export interface IServiceApplyConfig {
  readonly [key: string]: {
    readonly icon: string;
    readonly description: string;
    readonly docLink: ReadonlyArray<{
      readonly title: string;
      readonly url: string;
      readonly description: string;
    }>;
  };
}

export interface IApplyDataList {
  readonly title: string;
  readonly commonServices: IAPIServiceConfigItem[];
  readonly checkedList: IAPIServiceConfigItem[];
  readonly parentSort: number;
}

export interface IServiceApplyCreateItem {
  readonly serviceID: number;
  readonly isRecommended?: boolean;
  readonly isRelation?: boolean;
  readonly subName?: ReadonlyArray<string>;
  readonly applyInfo?: string;
}

export interface IServiceApplyCreateDto {
  readonly serviceItems: Record<string, IServiceApplyCreateItem>;
  readonly toLink: string;
  readonly gameID: string;
  readonly envID: number;
}

export interface IServiceAllEnvs {
  readonly status: number;
  readonly subserviceName: string | null;
  readonly serviceID: number;
  readonly stage: string;
}

export enum EnableType {
  OpenFull = 0,
  PrivacyWhitelist = 1,
  IPWhitelist = 2,
}

export enum DevopsProject {
  Test = 'g6omstest',
  Cn = 'gaas-cn',
  Singapore = 'gos-backend',
}

export enum IAuditModule {
  Organization = 'Organization',
  Billing = 'Billing',
  Audithub = 'Audithub',
  GameInfo = 'GameInfo',
  Setting = 'Setting',
  // ClientAPI = 'ClientAPI',
  EnvironmentManagement = 'EnvironmentManagement',
  EnvironmentSync = 'EnvironmentSync',
  ServerControl = 'ServerControl',
  ClientAPIControl = 'ClientAPIControl',
}

export enum IAuditItem {
  ViewOrganizationMembers = 'ViewOrganizationMembers',
  ViewOrganizationApplications = 'ViewOrganizationApplications',
  ViewOrganizationGroups = 'ViewOrganizationGroups',
  ViewOrganizationRoles = 'ViewOrganizationRoles',
  ViewOrganizationGroup = 'ViewOrganizationGroup',
  ViewOrganizationRole = 'ViewOrganizationRole',

  ViewBilling = 'ViewBilling',

  ViewAudithubTask = 'ViewAudithubTask',
  ViewAudithubOperationreport = 'ViewAudithubOperationreport',
  DownloadOperationreport = 'DownloadOperationreport',

  ViewGameBasicInf = 'ViewGameBasicInf',
  CopyTitleKey = 'CopyTitleKey',
  ViewGameEnvironments = 'ViewGameEnvironments',
  ChooseOpenType = 'ChooseOpenType',
  CloseGameEnvironment = 'CloseGameEnvironment',

  InviteOrganizationMember = 'InviteOrganizationMember',
  RemoveOrganizationMember = 'RemoveOrganizationMember',

  DeleteOrganizationGroup = 'DeleteOrganizationGroup',
  EditOrganizationGroup = 'EditOrganizationGroup',
  AddNewOrganizationGroup = 'AddNewOrganizationGroup',

  AddNewOrganizationRole = 'AddNewOrganizationRole',
  EditOrganizationRole = 'EditOrganizationRole',
  DeleteOrganizationRole = 'DeleteOrganizationRole',

  EditGameTitle = 'EditGameTitle',
  DeleteGameTitle = 'DeleteGameTitle',

  AddGameEnvironment = 'AddGameEnvironment',
  EditGameEnvironment = 'EditGameEnvironment',
  DeleteGameEnvironment = 'DeleteGameEnvironment',
  GameEnvironmentSync = 'GameEnvironmentSync',

  ApproveApplication = 'ApproveApplication',
  RefuseApplication = 'RefuseApplication',

  ViewSetting = 'ViewSetting',
  EditStudio = 'EditStudio',
  DeleteStudio = 'DeleteStudio',
  SubmitStudioCertification = 'SubmitStudioCertification',
  EditStudioCertification = 'EditStudioCertification',

  ViewClientAPIControl = 'ViewClientAPIControl',
  EnableClientAPI = 'EnableClientAPI',
  DisableClientAPI = 'DisableClientAPI',
  DiscardAllClientAPI = 'DiscardAllClientAPI',
  PublishClientAPI = 'PublishClientAPI',
}

export enum IAuditOperateType {
  Read = 'read',
  Write = 'write',
}

export enum IAuditEnvType {
  Dev = 'Dev',
  Prod = 'Prod',
}

export interface IAuditLogBody {
  studio_id?: string;
  game_id?: string;
  env_id?: string | number;
  env_type: IAuditEnvType;
  module: string; // 功能模块
  item: string; // 操作项名称,
  type: IAuditOperateType;
  detail: Record<string, any>; // json字符串, 传递操作详情, 比如接口的参数, 返回等
}

export interface IServiceApplyInfo {
  readonly id: number;
  readonly GameID: string;
  readonly ServiceID: number;
  readonly Applicant: string;
  readonly ApplyInfo: string;
  readonly CreateTime: string;
  readonly ModifyTime: string;
}

export interface IClientAPIList {
  readonly api_name: string;
  readonly description_cn: string;
  readonly description_en: string;
  readonly is_developer_access_controlled: boolean;
  readonly maintainer: string;
  readonly module_name: string;
  readonly package_name_service_name: string;
  readonly service_name: string;
  readonly service_name_cn: string;
}

export interface IClientAPIDrafts {
  readonly client_api_key: string;
  readonly creator: string;
  readonly draft_is_enabled: number;
  readonly draft_modify_time: string;
  readonly draft_operator: string;
  readonly env_id: string;
  readonly game_id: number;
  readonly id: number;
  readonly is_published: number;
  readonly operator: string;
  readonly package_name_service_name: string;
  readonly published_is_enabled: number;
  readonly published_modify_time: string;
  readonly published_operator: string;
  readonly service: string;
}

export interface IClientAPIResult {
  readonly api_list: IClientAPIList[];
  readonly drafts: IClientAPIDrafts[];
}

export interface IClientAPI {
  readonly api_version: string;
  readonly code: number;
  readonly msg: string;
  readonly msg_en: string;
  readonly req: any;
  readonly request_id: string;
  readonly result: IClientAPIResult;
  readonly total: number;
}

interface IConfigEnvRegionItemValue {
  readonly deployRegion: string;
  readonly domain: string;
  readonly label: string;
  readonly value: GameEnvRegion;
}

interface IConfigEnvRegionItem {
  readonly IsPublic: number;
  readonly Status: number;
  readonly UniqueKey: string;
  readonly Value: IConfigEnvRegionItemValue[];
  readonly id: number;
}

export interface IConfigEnvRegion {
  readonly config_env_region: IConfigEnvRegionItem;
}

export interface IGauthServiceType {
  readonly gauthServiceType: string | null;
  readonly gauthServiceTypeName: string | null;
  readonly gameID: string;
}

export interface IGauthApplyBody {
  readonly serviceType: string;
  readonly applyMonth: number;
  readonly applyDesc: string;
}

export interface IGauthModifyBody {
  readonly flowId: string;
  readonly applyMonth: number;
  readonly applyDesc: string;
}

export interface IServerVersionResult {
  readonly original_env_version: string;
  readonly matched_server_version: string;
  readonly server_version: string;
}
export interface IServerVersion {
  readonly code: number;
  readonly msg_en: string;
  readonly result: IServerVersionResult;
  readonly api_version: string;
}
